/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Discard_DescInputs */

const vi_shop_home_discard_desc = /** @type {(inputs: Shop_Home_Discard_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khối đang sửa có thay đổi chưa lưu. Chuyển khối sẽ bỏ các thay đổi này.`)
};

/**

* @param {Shop_Home_Discard_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_discard_desc = /** @type {((inputs?: Shop_Home_Discard_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Discard_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_discard_desc(inputs)
});